{
  "Clear search": "Išvalyti iešką"
}
